<a *ngFor="let link of links" [href]="link.url" shrdUicButton variant="tertiaryFlyout" class="w-100 m-0">
  <span>{{ link.title }}</span>
</a>
